import PageWrapper from "../../components/page-wrapper/page-wrapper";
import {ParallaxImage} from "../../components/parallax-image/parallax-image";
import {aboutUsBody, whatWeSupportBody} from "./constants";
import bellaAboutUs from './img/bella-about.jpg'
import {MissionStatement} from "../homepage/bellas-mission-statement";
import HeadingUnderline from "../../components/heading-underline/heading-underline";

const AboutUs = () => {
    return (
        <PageWrapper>
            <ParallaxImage backgroundImage={`url(${bellaAboutUs})`}/>
            <div className="hero-container px-4 py-5">
                <div className="col-md-6 mx-auto my-5"/>
            </div>
            <div className="container-fluid bg-light section-padding">
                <div className="container">
                    <h1 className="display-4 text-center text-red section-title">About Us</h1>
                    <HeadingUnderline />
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            {MissionStatement.map((par, idx) => <p key={`statement-par-${idx}`} className="lead">{par}</p>)}
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-red text-white container-fluid section-padding">
                <div className="container">
                    <h2 className="text-center section-title">What is VEDS?</h2>
                    <HeadingUnderline className='white' />
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            {aboutUsBody.map((par, idx) => <p key={`statement-par-${idx}`}>{par}</p>)}
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid bg-light section-padding">
                <div className="container">
                    <h2 className="text-center text-red section-title">What does Bella's Mission support?</h2>
                    <HeadingUnderline />
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            {whatWeSupportBody.map((par, idx) => <p key={`statement-par-${idx}`}>{par}</p>)}
                        </div>
                    </div>
                </div>
            </div>
        </PageWrapper>
    );
};

export default AboutUs;